export { initBrowserMetricsV3, startPageLoad, perfMark } from './browser-metrics-v3';
